(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["goyojo-video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('goyojo-video-carousel')) {
    class GoyojoVideoCarousel extends HTMLElement {
      connectedCallback() {
        if (this.connected) return;
        this.connected = true;
        this.abortController = new AbortController();
        this.signal = this.abortController.signal;
        this.viewport = this.querySelector('[data-carousel-viewport]');
        this.track = this.querySelector('[data-carousel-track]');
        this.cards = Array.from(this.querySelectorAll('[data-video-card]'));
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.viewer = this.querySelector('[data-video-viewer]');
        this.loop = this.dataset.loop === 'true';
        this.autoplay = this.dataset.autoplay === 'true';
        this.muteDefault = this.dataset.muteDefault === 'true';
        this.popupEnabled = this.dataset.popup === 'true';
        this.wheelNavigation = this.dataset.wheelNavigation === 'true';
        this.keyboardNavigation = this.dataset.keyboardNavigation === 'true';
        this.mobileSwipe = this.dataset.mobileSwipe === 'true';
        this.autoAdvance = this.dataset.autoAdvance === 'true';
        this.activeIndex = this.clampIndex(Number(this.dataset.initialIndex || 0));
        this.viewerIndex = this.activeIndex;
        this.inView = false;
        this.viewerOpen = false;
        this.ignoreCardClick = false;
        this.pointer = null;
        this.scrollFrame = 0;
        this.playTimer = 0;
        this.resizeTimer = 0;
        this.loopTimer = 0;
        this.viewerSequence = 0;
        this.viewerSwitching = false;
        this.normalizingLoop = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (!this.viewport || !this.cards.length) return;
        this.prepareCarouselItems();
        this.bindCarousel();
        this.bindCards();
        this.bindViewer();
        this.observeVisibility();
        this.setActive(this.activeIndex, false, true);
        requestAnimationFrame(() => requestAnimationFrame(() => this.centerCard(this.activeIndex, 'auto', 0, true)));
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.intersectionObserver?.disconnect();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
        clearTimeout(this.playTimer);
        clearTimeout(this.resizeTimer);
        clearTimeout(this.loopTimer);
        this.closeViewer(true);
        this.restoreViewer();
        this.pauseCarouselVideos();
        this.removeLoopClones();
        this.connected = false;
      }

      clampIndex(index) {
        if (!this.cards?.length) return 0;
        return Math.max(0, Math.min(this.cards.length - 1, Number.isFinite(index) ? index : 0));
      }

      prepareCarouselItems() {
        this.removeLoopClones();
        this.cards.forEach((card, index) => {
          card.dataset.carouselItem = '';
          card.dataset.logicalIndex = String(index);
        });
        if (this.loop && this.cards.length > 1) {
          const before = document.createDocumentFragment();
          const after = document.createDocumentFragment();
          this.cards.forEach((card, index) => {
            before.append(this.createLoopClone(card, index));
            after.append(this.createLoopClone(card, index));
          });
          this.track.insertBefore(before, this.cards[0]);
          this.track.append(after);
        }
        this.items = Array.from(this.track.querySelectorAll('[data-carousel-item]'));
      }

      createLoopClone(card, index) {
        const clone = card.cloneNode(true);
        clone.removeAttribute('data-video-card');
        clone.removeAttribute('data-index');
        clone.removeAttribute('data-block-id');
        clone.removeAttribute('aria-current');
        clone.dataset.loopClone = '';
        clone.dataset.carouselItem = '';
        clone.dataset.logicalIndex = String(index);
        clone.setAttribute('aria-hidden', 'true');
        clone.classList.remove('is-active', 'is-playing');
        clone.querySelectorAll('video, template, [data-card-control]').forEach((element) => element.remove());
        [clone, ...clone.querySelectorAll('*')].forEach((element) => {
          element.removeAttribute('id');
          Array.from(element.attributes).forEach((attribute) => {
            if (attribute.name.startsWith('data-shopify')) element.removeAttribute(attribute.name);
          });
        });
        clone.querySelectorAll('button, a, input, select, textarea, [tabindex]').forEach((element) => {
          element.tabIndex = -1;
        });
        return clone;
      }

      removeLoopClones() {
        this.track?.querySelectorAll('[data-loop-clone]').forEach((clone) => clone.remove());
        this.items = this.cards ? [...this.cards] : [];
      }

      bindCarousel() {
        this.viewport.addEventListener('scroll', () => this.onCarouselScroll(), { passive: true, signal: this.signal });
        this.viewport.addEventListener('scrollend', () => this.normalizeLoopPosition(), { passive: true, signal: this.signal });
        this.viewport.addEventListener('wheel', (event) => this.onCarouselWheel(event), { passive: false, signal: this.signal });
        this.viewport.addEventListener('pointerdown', (event) => this.onPointerDown(event), { signal: this.signal });
        this.viewport.addEventListener('pointermove', (event) => this.onPointerMove(event), { signal: this.signal });
        this.viewport.addEventListener('pointerup', (event) => this.onPointerUp(event), { signal: this.signal });
        this.viewport.addEventListener('pointercancel', (event) => this.onPointerUp(event), { signal: this.signal });
        this.viewport.addEventListener('dragstart', (event) => event.preventDefault(), { signal: this.signal });
        this.previousButton?.addEventListener('click', () => this.stepCarousel(-1), { signal: this.signal });
        this.nextButton?.addEventListener('click', () => this.stepCarousel(1), { signal: this.signal });
        this.track.addEventListener('click', (event) => this.onLoopCloneClick(event), { signal: this.signal });
        this.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), { signal: this.signal });
        window.addEventListener('resize', () => this.onResize(), { passive: true, signal: this.signal });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.onResize());
          this.resizeObserver.observe(this.viewport);
        }
      }

      bindCards() {
        this.cards.forEach((card, index) => {
          const video = card.querySelector('video');
          const playButton = card.querySelector('[data-card-play]');
          const muteButton = card.querySelector('[data-card-mute]');
          card.addEventListener('click', (event) => this.onCardClick(event, index), { signal: this.signal });
          playButton?.addEventListener('click', (event) => {
            event.stopPropagation();
            this.setActive(index, true);
            clearTimeout(this.playTimer);
            this.toggleCarouselVideo(index);
          }, { signal: this.signal });
          muteButton?.addEventListener('click', (event) => {
            event.stopPropagation();
            this.setActive(index, true);
            clearTimeout(this.playTimer);
            this.toggleCarouselMute(index);
          }, { signal: this.signal });
          if (video) {
            video.playsInline = true;
            video.preload = 'none';
            video.addEventListener('play', () => this.updateCardPlayback(card, true), { signal: this.signal });
            video.addEventListener('pause', () => this.updateCardPlayback(card, false), { signal: this.signal });
            video.addEventListener('ended', () => this.updateCardPlayback(card, false), { signal: this.signal });
          }
        });
      }

      bindViewer() {
        if (!this.viewer) return;
        this.viewerStage = this.viewer.querySelector('[data-viewer-stage]');
        this.viewerWrapper = this.viewer.querySelector('[data-viewer-video-wrapper]');
        this.viewerProgress = this.viewer.querySelector('[data-viewer-progress]');
        this.viewerPlay = this.viewer.querySelector('[data-viewer-play]');
        this.viewerMute = this.viewer.querySelector('[data-viewer-mute]');
        this.viewerExpand = this.viewer.querySelector('[data-viewer-expand]');
        this.viewerPrevious = this.viewer.querySelector('[data-viewer-previous]');
        this.viewerNext = this.viewer.querySelector('[data-viewer-next]');
        this.viewerClose = this.viewer.querySelector('[data-viewer-close]');
        this.viewerShare = this.viewer.querySelector('[data-viewer-share]');
        this.viewerFavorite = this.viewer.querySelector('[data-viewer-favorite]');
        this.viewer.querySelector('[data-viewer-overlay]')?.addEventListener('click', () => this.closeViewer(), { signal: this.signal });
        this.viewerClose?.addEventListener('click', () => this.closeViewer(), { signal: this.signal });
        this.viewerPrevious?.addEventListener('click', () => this.changeViewer(-1), { signal: this.signal });
        this.viewerNext?.addEventListener('click', () => this.changeViewer(1), { signal: this.signal });
        this.viewerPlay?.addEventListener('click', (event) => {
          event.stopPropagation();
          this.toggleViewerPlayback();
        }, { signal: this.signal });
        this.viewerMute?.addEventListener('click', () => this.toggleViewerMute(), { signal: this.signal });
        this.viewerExpand?.addEventListener('click', () => this.toggleViewerExpand(), { signal: this.signal });
        this.viewerFavorite?.addEventListener('click', () => this.toggleFavorite(), { signal: this.signal });
        this.viewerShare?.addEventListener('click', () => this.shareViewer(), { signal: this.signal });
        this.viewer.addEventListener('wheel', (event) => this.onViewerWheel(event), { passive: false, signal: this.signal });
        this.viewerWrapper?.addEventListener('touchstart', (event) => this.onViewerTouchStart(event), { passive: true, signal: this.signal });
        this.viewerWrapper?.addEventListener('touchend', (event) => this.onViewerTouchEnd(event), { passive: true, signal: this.signal });
        document.addEventListener('keydown', (event) => this.onViewerKeydown(event), { signal: this.signal });
        document.addEventListener('goyojo:video-viewer-open', (event) => {
          if (event.detail?.instance !== this && this.viewerOpen) this.closeViewer(true);
        }, { signal: this.signal });
        if (this.viewerShare && typeof navigator.share !== 'function') this.viewerShare.hidden = true;
        this.portalViewer();
      }

      portalViewer() {
        if (!this.viewer || this.viewer.parentNode === document.body) return;
        this.viewerOrigin = this.viewer.parentNode;
        this.viewerOriginNext = this.viewer.nextSibling;
        const styles = getComputedStyle(this);
        const opacity = styles.getPropertyValue('--goyojo-overlay-opacity').trim() || '0.88';
        this.viewer.style.setProperty('--goyojo-overlay-opacity', opacity);
        this.viewer.style.fontFamily = styles.fontFamily;
        document.body.append(this.viewer);
      }

      restoreViewer() {
        if (!this.viewer || !this.viewerOrigin) return;
        const reference = this.viewerOriginNext?.parentNode === this.viewerOrigin ? this.viewerOriginNext : null;
        this.viewerOrigin.insertBefore(this.viewer, reference);
        this.viewer.style.removeProperty('--goyojo-overlay-opacity');
        this.viewer.style.removeProperty('font-family');
        this.viewerOrigin = null;
        this.viewerOriginNext = null;
      }

      observeVisibility() {
        if (!('IntersectionObserver' in window)) {
          this.inView = true;
          this.playActiveVideo();
          return;
        }
        this.intersectionObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          this.inView = Boolean(entry?.isIntersecting && entry.intersectionRatio > 0.12);
          if (this.inView && !this.viewerOpen) this.queueActivePlayback();
          if (!this.inView && !this.viewerOpen) this.pauseCarouselVideos();
        }, { threshold: [0, 0.12, 0.35] });
        this.intersectionObserver.observe(this);
      }

      onCarouselScroll() {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          const closest = this.closestCardIndex();
          if (closest !== this.activeIndex) this.setActive(closest, false);
          if (!this.normalizingLoop) this.queueLoopNormalization();
        });
      }

      onCarouselWheel(event) {
        if (!event.shiftKey || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
        event.preventDefault();
        this.viewport.scrollLeft += event.deltaY;
      }

      onPointerDown(event) {
        if (event.pointerType === 'touch' || event.button !== 0 || event.target.closest('[data-card-control]')) return;
        this.pointer = {
          id: event.pointerId,
          startX: event.clientX,
          startScroll: this.viewport.scrollLeft,
          moved: false
        };
      }

      onPointerMove(event) {
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        const delta = event.clientX - this.pointer.startX;
        if (!this.pointer.moved && Math.abs(delta) > 5) {
          this.pointer.moved = true;
          this.viewport.setPointerCapture?.(event.pointerId);
          this.viewport.classList.add('is-dragging');
        }
        if (!this.pointer.moved) return;
        event.preventDefault();
        this.viewport.scrollLeft = this.pointer.startScroll - delta;
      }

      onPointerUp(event) {
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        const moved = this.pointer.moved;
        if (moved && this.viewport.hasPointerCapture?.(event.pointerId)) {
          this.viewport.releasePointerCapture(event.pointerId);
        }
        this.viewport.classList.remove('is-dragging');
        this.pointer = null;
        if (moved) {
          this.ignoreCardClick = true;
          const index = this.closestCardIndex();
          this.setActive(index, true);
          setTimeout(() => { this.ignoreCardClick = false; }, 0);
        }
      }

      onLoopCloneClick(event) {
        const clone = event.target.closest?.('[data-loop-clone]');
        const trigger = event.target.closest?.('[data-card-open]');
        if (!clone || !trigger || this.ignoreCardClick) return;
        const index = this.clampIndex(Number(clone.dataset.logicalIndex));
        this.normalizeLoopPosition(index);
        this.activateCard(index, this.cards[index]?.querySelector('[data-card-open]'));
      }

      onCardClick(event, index) {
        if (event.target.closest('[data-card-control]')) return;
        const trigger = event.target.closest('[data-card-open]');
        if (!trigger) return;
        if (this.ignoreCardClick) {
          event.preventDefault();
          return;
        }
        this.activateCard(index, trigger);
      }

      activateCard(index, trigger) {
        const card = this.cards[index];
        if (!card) return;
        this.setActive(index, true);
        const hasVideo = Boolean(card.querySelector('[data-viewer-video-template]'));
        if (this.popupEnabled && hasVideo) {
          this.openViewer(index, trigger);
          return;
        }
        const link = card.dataset.link;
        if (link) window.location.assign(link);
      }

      onBlockSelect(event) {
        const card = event.target.closest?.('[data-video-card]') || this.cards.find((item) => item.dataset.blockId === event.detail?.blockId);
        if (!card || !this.contains(card)) return;
        const index = this.cards.indexOf(card);
        if (index >= 0) this.setActive(index, true);
      }

      onResize() {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          this.centerCard(this.activeIndex, 'auto', 0, true);
          this.setActive(this.closestCardIndex(), false, true);
        }, 120);
      }

      closestCarouselItem() {
        const viewportRect = this.viewport.getBoundingClientRect();
        const center = viewportRect.left + viewportRect.width / 2;
        let closest = this.cards[this.activeIndex];
        let distance = Infinity;
        this.items.forEach((item) => {
          const rect = item.getBoundingClientRect();
          const current = Math.abs(rect.left + rect.width / 2 - center);
          if (current < distance) {
            distance = current;
            closest = item;
          }
        });
        return closest;
      }

      closestCardIndex() {
        const item = this.closestCarouselItem();
        return this.clampIndex(Number(item?.dataset.logicalIndex ?? this.activeIndex));
      }

      setActive(index, center = false, immediate = false, direction = 0) {
        index = this.clampIndex(index);
        const changed = index !== this.activeIndex;
        if (changed) this.pauseCarouselVideos();
        this.activeIndex = index;
        this.items.forEach((item) => {
          item.classList.toggle('is-active', Number(item.dataset.logicalIndex) === index);
        });
        this.cards.forEach((card, cardIndex) => {
          const active = cardIndex === index;
          card.setAttribute('aria-current', active ? 'true' : 'false');
          card.querySelectorAll('[data-card-control]').forEach((control) => {
            control.tabIndex = active ? 0 : -1;
            control.setAttribute('aria-hidden', String(!active));
          });
          if (!active) {
            const video = card.querySelector('video');
            if (video) video.muted = true;
            this.updateMuteButton(card, true);
          }
        });
        this.updateCarouselButtons();
        if (center) this.centerCard(index, immediate || this.reducedMotion.matches ? 'auto' : 'smooth', direction);
        if (!this.viewerOpen) this.queueActivePlayback();
      }

      centerCard(index, behavior = 'smooth', direction = 0, preferOriginal = false) {
        const viewportRect = this.viewport.getBoundingClientRect();
        const center = viewportRect.left + viewportRect.width / 2;
        const candidates = preferOriginal
          ? [this.cards[index]]
          : this.items.filter((item) => Number(item.dataset.logicalIndex) === index);
        const available = candidates.filter(Boolean).map((item) => {
          const rect = item.getBoundingClientRect();
          return { item, delta: rect.left + rect.width / 2 - center };
        });
        let target;
        if (direction > 0) {
          target = available.filter((entry) => entry.delta > 1).sort((a, b) => a.delta - b.delta)[0];
        } else if (direction < 0) {
          target = available.filter((entry) => entry.delta < -1).sort((a, b) => b.delta - a.delta)[0];
        }
        target ||= available.sort((a, b) => Math.abs(a.delta) - Math.abs(b.delta))[0];
        if (!target) return;
        const left = this.viewport.scrollLeft + target.delta;
        if (behavior === 'auto') {
          const previousBehavior = this.viewport.style.scrollBehavior;
          this.viewport.style.scrollBehavior = 'auto';
          this.viewport.scrollLeft = left;
          requestAnimationFrame(() => { this.viewport.style.scrollBehavior = previousBehavior; });
          return;
        }
        this.viewport.scrollTo({ left, behavior });
      }

      stepCarousel(direction) {
        let next = this.activeIndex + direction;
        if (next < 0 || next >= this.cards.length) {
          if (!this.loop) return;
          next = next < 0 ? this.cards.length - 1 : 0;
        }
        this.setActive(next, true, false, direction);
      }

      queueLoopNormalization() {
        if (!this.loop || this.cards.length < 2 || this.normalizingLoop) return;
        clearTimeout(this.loopTimer);
        this.loopTimer = setTimeout(() => this.normalizeLoopPosition(), 140);
      }

      normalizeLoopPosition(forcedIndex = null) {
        if (!this.loop || this.cards.length < 2 || this.normalizingLoop) return;
        clearTimeout(this.loopTimer);
        const closest = this.closestCarouselItem();
        const index = forcedIndex === null
          ? this.clampIndex(Number(closest?.dataset.logicalIndex ?? this.activeIndex))
          : this.clampIndex(forcedIndex);
        if (forcedIndex === null && !closest?.hasAttribute('data-loop-clone')) return;
        const target = this.cards[index];
        if (!target) return;
        const viewportRect = this.viewport.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        const delta = targetRect.left + targetRect.width / 2 - (viewportRect.left + viewportRect.width / 2);
        this.normalizingLoop = true;
        const previousBehavior = this.viewport.style.scrollBehavior;
        this.viewport.style.scrollBehavior = 'auto';
        this.viewport.scrollLeft += delta;
        this.setActive(index, false, true);
        requestAnimationFrame(() => {
          this.viewport.style.scrollBehavior = previousBehavior;
          this.normalizingLoop = false;
        });
      }

      updateCarouselButtons() {
        if (this.previousButton) this.previousButton.disabled = !this.loop && this.activeIndex === 0;
        if (this.nextButton) this.nextButton.disabled = !this.loop && this.activeIndex === this.cards.length - 1;
      }

      queueActivePlayback() {
        clearTimeout(this.playTimer);
        this.playTimer = setTimeout(() => this.playActiveVideo(), 140);
      }

      playActiveVideo() {
        if (!this.inView || this.viewerOpen) return;
        const card = this.cards[this.activeIndex];
        const video = card?.querySelector('video');
        if (!video) return;
        this.pauseCarouselVideos(video);
        const shouldMute = this.muteDefault || card.dataset.muted === 'true';
        video.muted = shouldMute;
        video.playsInline = true;
        video.preload = 'metadata';
        this.updateMuteButton(card, video.muted);
        if (!this.autoplay || card.dataset.autoplay !== 'true') {
          this.updateCardPlayback(card, false);
          return;
        }
        const promise = video.play();
        if (promise) promise.catch(() => this.updateCardPlayback(card, false));
      }

      pauseCarouselVideos(except = null) {
        this.cards?.forEach((card) => {
          const video = card.querySelector('video');
          if (!video || video === except) return;
          video.pause();
          video.muted = true;
          this.updateCardPlayback(card, false);
          this.updateMuteButton(card, true);
        });
      }

      toggleCarouselVideo(index) {
        const card = this.cards[index];
        const video = card?.querySelector('video');
        if (!video) return;
        if (video.paused) {
          this.pauseCarouselVideos(video);
          video.preload = 'metadata';
          const promise = video.play();
          if (promise) promise.catch(() => this.updateCardPlayback(card, false));
        } else {
          video.pause();
        }
      }

      toggleCarouselMute(index) {
        const card = this.cards[index];
        const video = card?.querySelector('video');
        if (!video) return;
        this.pauseCarouselVideos(video);
        video.muted = !video.muted;
        this.updateMuteButton(card, video.muted);
        if (video.paused) {
          const promise = video.play();
          if (promise) promise.catch(() => this.updateCardPlayback(card, false));
        }
      }

      updateCardPlayback(card, playing) {
        card?.classList.toggle('is-playing', playing);
        const button = card?.querySelector('[data-card-play]');
        if (button) button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      }

      updateMuteButton(card, muted) {
        const button = card?.querySelector('[data-card-mute]');
        if (!button) return;
        button.dataset.muted = String(muted);
        button.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      }

      async openViewer(index, trigger) {
        if (!this.viewer || this.viewerOpen) return;
        document.dispatchEvent(new CustomEvent('goyojo:video-viewer-open', { detail: { instance: this } }));
        this.viewerOpen = true;
        this.viewerTrigger = trigger;
        this.viewerMuted = this.muteDefault || this.cards[index]?.dataset.muted === 'true';
        this.pauseCarouselVideos();
        this.lockBodyScroll();
        this.viewer.hidden = false;
        this.viewer.removeAttribute('inert');
        this.viewer.setAttribute('aria-hidden', 'false');
        this.viewer.classList.remove('is-closing');
        await this.loadViewerVideo(index, 0, true);
        requestAnimationFrame(() => this.viewer?.classList.add('is-open'));
        setTimeout(() => this.viewerClose?.focus(), this.reducedMotion.matches ? 0 : 80);
      }

      closeViewer(immediate = false) {
        if (!this.viewer || (!this.viewerOpen && !immediate)) return;
        const returnFocus = this.viewerTrigger;
        this.viewerOpen = false;
        this.viewerSequence += 1;
        this.viewerSwitching = false;
        this.releaseViewerVideo();
        this.viewer.classList.remove('is-open', 'is-expanded');
        this.viewer.classList.add('is-closing');
        this.viewerExpand?.setAttribute('aria-pressed', 'false');
        this.unlockBodyScroll();
        const finish = () => {
          if (!this.viewer || this.viewerOpen) return;
          this.viewer.hidden = true;
          this.viewer.setAttribute('inert', '');
          this.viewer.setAttribute('aria-hidden', 'true');
          this.viewer.classList.remove('is-closing');
          if (!immediate && returnFocus?.isConnected) returnFocus.focus();
          if (!immediate && this.inView) this.queueActivePlayback();
        };
        if (immediate || this.reducedMotion.matches) finish();
        else setTimeout(finish, 260);
      }

      lockBodyScroll() {
        if (this.bodyLocked) return;
        this.bodyLocked = true;
        this.previousBodyOverflow = document.body.style.overflow;
        this.previousBodyPaddingRight = document.body.style.paddingRight;
        this.previousRootOverflow = document.documentElement.style.overflow;
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`;
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
      }

      unlockBodyScroll() {
        if (!this.bodyLocked) return;
        document.body.style.overflow = this.previousBodyOverflow || '';
        document.body.style.paddingRight = this.previousBodyPaddingRight || '';
        document.documentElement.style.overflow = this.previousRootOverflow || '';
        this.bodyLocked = false;
      }

      async loadViewerVideo(index, direction = 0, initial = false) {
        const card = this.cards[this.clampIndex(index)];
        const template = card?.querySelector('[data-viewer-video-template]');
        if (!template || !this.viewerWrapper) return;
        const sequence = ++this.viewerSequence;
        this.viewerSwitching = true;
        const duration = this.reducedMotion.matches ? 0 : 150;
        if (!initial && this.viewerVideo && duration) {
          const y = direction > 0 ? '-8%' : '8%';
          await this.runViewerAnimation([
            { opacity: 1, transform: 'translateY(0)' },
            { opacity: 0, transform: `translateY(${y})` }
          ], { duration, easing: 'ease-out' });
        }
        if (sequence !== this.viewerSequence || !this.viewerOpen) return;
        this.releaseViewerVideo();
        const fragment = template.content.cloneNode(true);
        const playButton = this.viewerPlay;
        this.viewerWrapper.replaceChildren(fragment);
        if (playButton) this.viewerWrapper.append(playButton);
        this.viewerVideo = this.viewerWrapper.querySelector('video');
        if (!this.viewerVideo) return;
        this.viewerIndex = this.cards.indexOf(card);
        this.viewerVideoAbort = new AbortController();
        const videoSignal = this.viewerVideoAbort.signal;
        this.viewerVideo.playsInline = true;
        this.viewerVideo.muted = this.viewerMuted;
        this.viewerVideo.loop = !this.autoAdvance && card.dataset.loop === 'true';
        this.viewerVideo.preload = 'auto';
        this.viewerVideo.addEventListener('timeupdate', () => this.updateViewerProgress(), { signal: videoSignal });
        this.viewerVideo.addEventListener('loadedmetadata', () => this.updateViewerAspect(), { signal: videoSignal });
        this.viewerVideo.addEventListener('play', () => this.updateViewerPlayback(true), { signal: videoSignal });
        this.viewerVideo.addEventListener('pause', () => this.updateViewerPlayback(false), { signal: videoSignal });
        this.viewerVideo.addEventListener('ended', () => this.onViewerEnded(), { signal: videoSignal });
        this.updateViewerMuteButton();
        this.updateViewerNavigation();
        this.updateViewerProgress(true);
        this.viewerWrapper.style.opacity = '1';
        this.viewerWrapper.style.transform = 'translateY(0)';
        this.viewerVideo.load();
        try { this.viewerVideo.currentTime = 0; } catch (error) { void error; }
        if (!initial && duration) {
          const y = direction > 0 ? '8%' : '-8%';
          await this.runViewerAnimation([
            { opacity: 0, transform: `translateY(${y})` },
            { opacity: 1, transform: 'translateY(0)' }
          ], { duration: 180, easing: 'ease-out' });
        }
        if (sequence !== this.viewerSequence || !this.viewerOpen) return;
        const promise = this.viewerVideo.play();
        if (promise) promise.catch(() => this.updateViewerPlayback(false));
        this.viewerSwitching = false;
      }

      async runViewerAnimation(keyframes, options) {
        this.viewerAnimation?.cancel();
        const animation = this.viewerWrapper.animate(keyframes, options);
        this.viewerAnimation = animation;
        try {
          await animation.finished;
        } catch (error) {
          if (error?.name !== 'AbortError') void error;
        } finally {
          if (this.viewerAnimation === animation) {
            animation.cancel();
            this.viewerAnimation = null;
          }
        }
      }

      releaseViewerVideo() {
        this.viewerAnimation?.cancel();
        this.viewerAnimation = null;
        this.viewerVideoAbort?.abort();
        this.viewerVideoAbort = null;
        if (this.viewerVideo) {
          this.viewerVideo.pause();
          this.viewerVideo.removeAttribute('src');
          this.viewerVideo.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
          this.viewerVideo.load();
        }
        this.viewerVideo = null;
        if (this.viewerWrapper) {
          const playButton = this.viewerPlay;
          this.viewerWrapper.replaceChildren();
          if (playButton) this.viewerWrapper.append(playButton);
          this.updateViewerPlayback(false);
          this.viewerWrapper.style.removeProperty('--goyojo-viewer-aspect');
        }
        this.updateViewerProgress(true);
      }

      changeViewer(direction) {
        if (!this.viewerOpen || this.viewerSwitching) return;
        const next = this.findViewerIndex(direction);
        if (next < 0) {
          this.updateViewerNavigation();
          return;
        }
        this.loadViewerVideo(next, direction);
      }

      findViewerIndex(direction) {
        if (this.cards.length < 2) return -1;
        let next = this.viewerIndex;
        for (let checked = 0; checked < this.cards.length - 1; checked += 1) {
          next += direction;
          if (next < 0 || next >= this.cards.length) {
            if (!this.loop) return -1;
            next = next < 0 ? this.cards.length - 1 : 0;
          }
          if (next !== this.viewerIndex && this.cards[next]?.querySelector('[data-viewer-video-template]')) return next;
        }
        return -1;
      }

      updateViewerNavigation() {
        if (this.viewerPrevious) this.viewerPrevious.disabled = this.findViewerIndex(-1) < 0;
        if (this.viewerNext) this.viewerNext.disabled = this.findViewerIndex(1) < 0;
      }

      updateViewerProgress(reset = false) {
        if (!this.viewerProgress) return;
        const duration = this.viewerVideo?.duration;
        const current = this.viewerVideo?.currentTime || 0;
        const progress = reset || !Number.isFinite(duration) || duration <= 0 ? 0 : Math.min(100, current / duration * 100);
        this.viewerProgress.style.width = `${progress}%`;
      }

      updateViewerAspect() {
        if (!this.viewerVideo || !this.viewerWrapper) return;
        const width = this.viewerVideo.videoWidth;
        const height = this.viewerVideo.videoHeight;
        if (width > 0 && height > 0) this.viewerWrapper.style.setProperty('--goyojo-viewer-aspect', `${width} / ${height}`);
      }

      onViewerEnded() {
        if (this.autoAdvance) {
          const next = this.findViewerIndex(1);
          if (next >= 0) {
            this.loadViewerVideo(next, 1);
          } else if (this.loop && this.viewerVideo) {
            this.viewerVideo.currentTime = 0;
            this.viewerVideo.play().catch(() => this.updateViewerPlayback(false));
          }
          return;
        }
        const card = this.cards[this.viewerIndex];
        if (card?.dataset.loop === 'true' && this.viewerVideo) {
          this.viewerVideo.currentTime = 0;
          this.viewerVideo.play().catch(() => this.updateViewerPlayback(false));
        }
      }

      toggleViewerPlayback() {
        if (!this.viewerVideo) return;
        if (this.viewerVideo.paused) this.viewerVideo.play().catch(() => this.updateViewerPlayback(false));
        else this.viewerVideo.pause();
      }

      updateViewerPlayback(playing) {
        this.viewerWrapper?.classList.toggle('is-playing', playing);
        if (!this.viewerPlay) return;
        this.viewerPlay.tabIndex = playing ? -1 : 0;
        this.viewerPlay.setAttribute('aria-hidden', String(playing));
        if (playing && document.activeElement === this.viewerPlay) this.viewerClose?.focus();
      }

      toggleViewerMute() {
        if (!this.viewerVideo) return;
        this.viewerMuted = !this.viewerVideo.muted;
        this.viewerVideo.muted = this.viewerMuted;
        this.updateViewerMuteButton();
      }

      updateViewerMuteButton() {
        if (!this.viewerMute) return;
        const muted = this.viewerVideo ? this.viewerVideo.muted : this.viewerMuted;
        this.viewerMute.dataset.muted = String(muted);
        this.viewerMute.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      }

      toggleViewerExpand() {
        if (!this.viewer) return;
        const expanded = this.viewer.classList.toggle('is-expanded');
        this.viewerExpand?.setAttribute('aria-pressed', String(expanded));
        this.viewerExpand?.setAttribute('aria-label', expanded ? 'Exit expanded view' : 'Expand video');
      }

      toggleFavorite() {
        if (!this.viewerFavorite) return;
        const pressed = this.viewerFavorite.getAttribute('aria-pressed') === 'true';
        this.viewerFavorite.setAttribute('aria-pressed', String(!pressed));
      }

      async shareViewer() {
        if (typeof navigator.share !== 'function') return;
        try {
          await navigator.share({ title: document.title, url: window.location.href });
        } catch (error) {
          if (error?.name !== 'AbortError') void error;
        }
      }

      onViewerKeydown(event) {
        if (!this.viewerOpen) return;
        const target = event.target;
        if (event.key === 'Tab') {
          this.trapViewerFocus(event);
          return;
        }
        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeViewer();
          return;
        }
        if (!this.keyboardNavigation) return;
        if (target?.matches?.('input, textarea, select, [contenteditable="true"]')) return;
        if (event.key === ' ' && target?.closest?.('button, a[href], [role="button"]')) return;
        const actions = {
          ArrowUp: () => this.changeViewer(-1),
          ArrowLeft: () => this.changeViewer(-1),
          ArrowDown: () => this.changeViewer(1),
          ArrowRight: () => this.changeViewer(1),
          ' ': () => this.toggleViewerPlayback(),
          m: () => this.toggleViewerMute(),
          M: () => this.toggleViewerMute()
        };
        const action = actions[event.key];
        if (!action) return;
        event.preventDefault();
        action();
      }

      trapViewerFocus(event) {
        const focusable = Array.from(this.viewer.querySelectorAll('button, [href], [tabindex]')).filter((element) => {
          return !element.hidden && !element.disabled && element.tabIndex >= 0 && element.getAttribute('aria-hidden') !== 'true' && element.offsetParent !== null;
        });
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      onViewerWheel(event) {
        if (!this.viewerOpen || !this.wheelNavigation || !window.matchMedia('(min-width: 768px)').matches) return;
        if (Math.abs(event.deltaY) < 18 || Math.abs(event.deltaY) < Math.abs(event.deltaX)) return;
        event.preventDefault();
        const now = Date.now();
        if (now - (this.lastViewerWheel || 0) < 700) return;
        this.lastViewerWheel = now;
        this.changeViewer(event.deltaY > 0 ? 1 : -1);
      }

      onViewerTouchStart(event) {
        if (!this.viewerOpen || event.touches.length !== 1) return;
        if (event.target.closest?.('button, a[href]')) {
          this.viewerTouch = null;
          return;
        }
        const touch = event.touches[0];
        this.viewerTouch = { x: touch.clientX, y: touch.clientY, time: Date.now() };
      }

      onViewerTouchEnd(event) {
        if (!this.viewerTouch || !this.viewerOpen || event.changedTouches.length !== 1) return;
        const touch = event.changedTouches[0];
        const dx = touch.clientX - this.viewerTouch.x;
        const dy = touch.clientY - this.viewerTouch.y;
        const distance = Math.max(Math.abs(dx), Math.abs(dy));
        const elapsed = Date.now() - this.viewerTouch.time;
        this.viewerTouch = null;
        if (distance < 10 && elapsed < 450) {
          this.toggleViewerPlayback();
          return;
        }
        if (!this.mobileSwipe || distance < 48) return;
        if (Math.abs(dy) >= Math.abs(dx)) this.changeViewer(dy < 0 ? 1 : -1);
        else this.changeViewer(dx < 0 ? 1 : -1);
      }
    }

    customElements.define('goyojo-video-carousel', GoyojoVideoCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
